module.exports = __webpack_public_path__ + "assets/icon_pause.bfba7d45.svg";